import React from 'react';
import iconSrc from './icon.png';

/**
 * LogoSVG — Logo vectorial Consuprog, fondo 100% transparente.
 * Se adapta a cualquier fondo de navbar sin artefactos.
 *
 * Props:
 *  - height: altura total en px (default 52)
 */
const LogoSVG = ({ height = 52, showTagline = true }) => {
  // Viewbox: 320 x 90  → ratio ~3.55 : 1
  const width = Math.round(height * 3.55);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 320 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Consuprog"
      style={{ display: 'block', flexShrink: 0 }}
    >
      {/* =====================================================
          ÍCONO  (90 x 90 viewport units)
          Marco tipo "W" / libro abierto verde + edificios 3D
          ===================================================== */}
      <g id="logo">

        {/* ÍCONO */}
        <image
          href={iconSrc}
          x="0"
          y="0"
          width="95"
          height="90"
          preserveAspectRatio="xMidYMid meet"
        />


        {/* =====================================================
          WORDMARK  (comienza en x=105)
          ===================================================== */}

        {/* CONSUPROG */}
        <text
          x="105"
          y="56"
          fontFamily="'Barlow Condensed', 'Arial Narrow', Arial, sans-serif"
          fontSize="42"
          letterSpacing="1.5"
          fill="#FFFFFF"
        >
          <tspan fontWeight="800">CONSUPRO</tspan>

          {/* G destacada SIN romper layout */}
          <tspan
            fontWeight="900"
            fontSize="45"
            dx="1"
          >
            G
          </tspan>
        </text>

        {showTagline && (
          <text
            x="107"
            y="71"
            fontFamily="'Barlow', Arial, sans-serif"
            fontWeight="400"
            fontSize="10.5"
            letterSpacing="3"
            fill="rgba(255,255,255,0.5)"
          >
            LO IMAGINAS - LO HACEMOS
          </text>
        )}
      </g>
    </svg>
  );
};

export default LogoSVG;
